<template>
  <b-modal
    id="addFilesModal2"
    cancel-variant="outline-secondary"
    :ok-title="$t('save')"
    :cancel-title="$t('general.close')"
    centered
    size="lg"
    no-close-on-backdrop
    :title="type == 'add' ? $t('adding_files') : $t('watch_files')"
    @ok="onSave()"
    @show="onShow()"
  >
    <!-- @close="onCancel()"
    @cancel="onCancel()" -->
      <div>
        <div class="d-flex align-items-center" 
        v-if="GET_ONE_CONTRACT &&
        GET_ONE_CONTRACT.status &&
        GET_ONE_CONTRACT.status.unique_name != 'close_contract'">

          <b-form-file
            v-model="file_upload"
            :browse-text="$t('general.select')"
            :placeholder="$t('select_a_file_or_drag_and_drop_it_here')"
            :drop-placeholder="$t('drag_file_here')"
            class="my-1"
          />

          <b-button @click="uploadFile" class="ml-1 d-flex" variant="primary" size="md">
            <feather-icon icon="UploadIcon" class="mr-25"/>
            {{$t('general.upload')}}
          </b-button>
        </div>
        

        <h6 class="font-weight-bold mt-1 mb-1">{{$t('file_table')}}</h6>
        <b-table
          :items="files"
          :current-page="currentPage"
          :per-page="perPage"
          :fields="fields"
          :filter-included-fields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          stacked="md"
          small
          hover   
          bordered
          select-mode="single"
          selectable
          show-empty
          responsive
          :empty-text="$t('empty_text')"
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>
        
          <!-- @row-selected="onRowSelected" -->
          <!-- :filter="filter" -->

          <template #cell(id)="row">
              {{ (row.index + 1) + ((currentPage-1) * perPage) }} 
          </template>

          <template #cell(title)="row">
            {{ row.item.name }} 
          </template>

          <template #cell(actions)="row">
            <div class="d-flex justify-content-center">
              <b-button
                  v-if="checkAndHideDownloadFileIfNeeded(row.item)"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="success"
                  class="mr-50 mt-50 mb-50"
                  size="sm"
                  @click="downloadFile(row.item.url)"
                  >
                  <feather-icon
                      icon="DownloadIcon"
                      class="mr-50"
                  />
                  <span class="align-middle">{{$t('download')}}</span>
              </b-button>
              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="danger"
                  class="mt-50 mb-50"
                  size="sm"
                  v-b-modal.modal-before-delete-file
                  @click="choosedForDeletion(row.item, row.index)"
                  >
                  <feather-icon
                      icon="Trash2Icon"
                      class="mr-50"
                  />
                  <span class="align-middle">{{$t('delete')}}</span>
              </b-button>
            </div>
          </template>
        </b-table>

        <b-modal
          id="modal-before-delete-file"
          :ok-title="$t('yes')"
          :cancel-title="$t('no')"
          ok-variant="success"
          cancel-variant="danger"
          centered
          :title="$t('attention')"
          @ok="deleteFile"
        >
          <b-card-text>
            {{$t('are_you_sure_you_want_to_delete_this_file')}}
          </b-card-text>
        </b-modal>
      </div>


  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BFormInput,
  BFormGroup,
  BRow,
  BCol,

  BCard,
  BButton,
  BInputGroupPrepend, 
  BInputGroup, 
  BTable, 
  BBadge, 
  BPagination,
  BFormSelect,
  BFormFile,
  BCardText,
} from 'bootstrap-vue'
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'


export default {
  components: {
    BModal,
    BFormInput,
    BFormGroup,
    vSelect,
    BRow,
    ValidationObserver,
    ValidationProvider,
    BCol,

    BCardText,
    BButton,
    FeatherIcon,
    BFormFile,
    BPagination,
    BFormSelect,
    BInputGroupPrepend,
    BInputGroup,
    BCard,
    BTable,
    BBadge,
    ToastificationContent
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    type: {
      type: [String],
      default: false,
    },
  },
  data() {
    return {
      file_upload: null,
      delete_file_index: '',
      delete_file_item: '',
      fields: [
          {
              label: '№',
              key: 'id',
              class: 'text-center',
              tdClass: ['idClass']
          },
          {
              label: 'general.title',
              key: 'title',
              class: 'text-left',
              tdClass: ['fileClass']
          },
          {
              label: 'actions',
              key: 'actions',
              class: 'text-center',
              tdClass: ['actionsClass']
          },
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 5,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
    }
  },
  watch: {
   
  },
  computed: {
    ...mapGetters('agrements', ['GET_ONE_CONTRACT']),





    // ========================= SETTERS_AND_GETTERS START =========================
    files: {
      get: function () {
        return this.$store.state.agrements.files;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_FILES', newValue)
      }
    },
    invoiceItems: {
      get: function () {
        return this.$store.state.agrements.invoiceItems;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_INVOICE_ITEMS', newValue)
      }
    },
    invoice_id: {
      get: function () {
        return this.$store.state.agrements.invoice_id;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_INVOICE_ID', newValue)
      }
    },
    // ========================= SETTERS_AND_GETTERS END =========================





  },
  async mounted() {

  },
  methods: {
    ...mapActions('agrements', [
      'UPDATE_PATCH_CONTRACT_INVOICE',
      'FETCH_ONE_CONTRACTS'
    ]),
    ...mapActions('taskManager', [
      'DELETE_ATTACHMENT_FILE'
    ]),





    // ========================= ON_SAVE START =========================
    async onSave() {
      let fd = new FormData()

      this.files.forEach((elem) => {fd.append('files', elem)})
      await this.UPDATE_PATCH_CONTRACT_INVOICE({data: fd, id: this.invoice_id})
      await this.FETCH_ONE_CONTRACTS(this.$route.params.id).then(() => {
        const { invoice } = this.GET_ONE_CONTRACT
        this.invoiceItems = invoice
      })
      this.onShow()

      this.$toast({
        component: ToastificationContent,
        position: "top-right",
        props: {
          icon: "AlertCircleIcon",
          variant: "success",
          text: this.$t('success'),
        },
      });
    },
    // ========================= ON_SAVE END =========================

 


    onShow(){
      let a = this.invoiceItems.find((item) => item.id == this.invoice_id)
      if(a){
        this.files = a.files
        this.files.forEach((elem) => {
          if(elem.url){
            elem.name = elem.url.substr(elem.url.lastIndexOf('/') + 1);
          }
        })
      }
    },





    // ========================= LOAD_MATERIALS_AND_INSTRUMENTS_TO_INPUTS START =========================

    // ========================= LOAD_MATERIALS_AND_INSTRUMENTS_TO_INPUTS END =========================


    ...mapMutations('agrements', ['PUSH_FILES']),
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    

    checkAndHideDownloadFileIfNeeded(item){
      if(item && item.url){
        return true
      }else{
        return false
      }
    },



    downloadFile(url) {
      // const url_parts = url.split('/')
      fetch(url).then(function(t) {
        return t.blob().then((b)=>{
          var a = document.createElement("a");
          a.href = URL.createObjectURL(b);
          let fileName = url.substr(url.lastIndexOf('/') + 1);
          a.setAttribute("download", fileName);
          a.click();
        }
        );
      });
    },






    async deleteFile() {
      if(this.delete_file_item && this.delete_file_item.url){
        const resp = await this.DELETE_ATTACHMENT_FILE(this.delete_file_item.id);
        await this.FETCH_ONE_CONTRACTS(this.$route.params.id).then(() => {
          const {
            invoice,
          } = this.GET_ONE_CONTRACT
  
          this.invoiceItems = invoice
        })
        this.onShow()
  
        if(resp.status == 204) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              icon: "AlertCircleIcon",
              variant: "success",
              text: this.$t('files_successfully_deleted'),
            },
          });
        }
      }else{
        this.files.splice(this.delete_file_index, 1)
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            icon: "AlertCircleIcon",
            variant: "success",
            text: this.$t('files_successfully_deleted'),
          },
        });
      }
    },


    choosedForDeletion(item, index){
      this.delete_file_item = item
      this.delete_file_index = index
    },






    async uploadFile() {
      if(this.file_upload){
        await this.PUSH_FILES(this.file_upload)
        this.totalRows = this.files.length
      }
    },





    
    
  },
}
</script>

<style>
.idClass{
  min-width: 50px !important;
  max-width: 100px !important;
}
.fileClass{
  min-width: 50px !important;
  max-width: 350px !important;
}
.actionsClass{
  min-width: 50px !important;
  max-width: 130px !important;
}
</style>
